import { render, staticRenderFns } from "./pdfYs.vue?vue&type=template&id=706cfb90&"
import script from "./pdfYs.vue?vue&type=script&lang=js&"
export * from "./pdfYs.vue?vue&type=script&lang=js&"
import style0 from "./pdfYs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports